export default "<ion-icon\n  (click)=\"toggleFollow()\"\n  tappable\n  [@bookmark]=\"bookmarkState\"\n  name=\"star-outline\"\n></ion-icon>\n"